export default __webpack_public_path__ + "static/media/computer.d9dd4ce4.png";